import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

const OrderSuccess = ({ urls }) => (
  <Fragment>
    <p>
      <strong>
        Merci pour votre demande de réservation, celle-ci a bien été
        enregistrée.
      </strong>
    </p>
    <p>
      Un récapitulatif est consultable{' '}
      <a href={urls.orderURL}>sur la page dédiée à votre réservation</a>.
    </p>
    <p>
      Nous l’avons transmise à notre partenaire qui va pouvoir confirmer sa
      disponibilité aussi vite que possible.
    </p>
    <p>
      <strong>
        Votre carte de crédit sera débitée uniquement si notre partenaire
        confirme votre réservation.
      </strong>
    </p>
    <p>
      Une fois celle-ci confirmée, vous recevrez un e-mail contenant toutes les
      informations nécessaires (adresse, numéro de l’animateur …) au bon
      déroulement de votre activité.
    </p>
    <p>
      Si l’animateur n’est pas disponible au créneau demandé, il pourra soit
      vous proposer un nouveau rendez-vous, soit refuser votre demande, auquel
      cas aucun prélèvement ne sera effectué sur votre carte bancaire.
    </p>
  </Fragment>
)

OrderSuccess.propTypes = {
  urls: PropTypes.object.isRequired
}

export default OrderSuccess
